import Image from "next/image";
import kinervaLogoSrc from "./kinerva.svg";
import cursorInsightLogoSecureSrc from "./cursor-insight-logo.svg";

const DomainMaps: Record<string, string> = {
  "www.cursorinsight.com": cursorInsightLogoSecureSrc,
  "www.kinerva.ai": kinervaLogoSrc,
  "www.graboxy.com": cursorInsightLogoSecureSrc,
  "www.signowise.com": cursorInsightLogoSecureSrc,
};

const Logo = ({
  tenantData,
}: {
  tenantData: { name?: string; domain?: string } | null;
}) => (
  <Image
    src={DomainMaps[tenantData?.domain ?? "www.kinerva.ai"] ?? kinervaLogoSrc}
    height={40}
    alt={`${tenantData?.name ?? "Kinerva"} Logo`}
    sizes="180px"
  />
);

export default Logo;
